import {
  ComponentSectionsOpenJobs,
  Job,
  JobEntity,
} from "@lib/generated/graphql";
import useLocale from "@lib/hooks/useLocale";
import getJobsData from "@lib/strapi/getJobsData";
import { FC, useEffect, useState } from "react";
import OpenJobsComponent from "./OpenJobsComponent";

const jobsMapper = (data: JobEntity[]) => {
  return data?.map((item) => item.attributes as Job);
};

type OpenJobsProps = {
  data: ComponentSectionsOpenJobs;
};

const OpenJobs: FC<OpenJobsProps> = ({ data }) => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const locale = useLocale();

  useEffect(() => {
    getJobsData({ locale, publicationState: "LIVE" }).then((data) => {
      if (data) {
        setJobs(jobsMapper(data));
      }
    });
  }, [locale]);

  return <OpenJobsComponent data={data} jobs={jobs} />;
};

export default OpenJobs;
